// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IBmWR","tabsBox":"styles_tabsBox__3kIzW","createButton":"styles_createButton__39RBS"};